/* Bull Kicks V2 cart drawer — auxiliary JS
   Rise's cart-drawer.js handles open/close/focus/section-render.
   Rise's cart.js handles qty AJAX + remove AJAX.
   This file only handles:
     - Upsell [+ 加入] inline add-to-cart
     - Persist horizontal scroll of upsell row across Rise's section re-renders
*/
(function () {
  'use strict';

  var SCROLL_KEY = 'bk-cart-upsell-scroll';

  function getDrawer() {
    return document.querySelector('cart-drawer[data-bk-cart-drawer]');
  }

  function restoreUpsellScroll() {
    var row = document.querySelector('[data-bk-upsell-row]');
    if (!row) return;
    try {
      var v = sessionStorage.getItem(SCROLL_KEY);
      if (v != null) row.scrollLeft = parseInt(v, 10) || 0;
    } catch (e) { /* sessionStorage unavailable */ }
    row.addEventListener('scroll', function () {
      try { sessionStorage.setItem(SCROLL_KEY, String(row.scrollLeft)); } catch (e) {}
    }, { passive: true });
  }

  function onUpsellAdd(btn) {
    if (btn.disabled) return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('is-loading');

    var body = JSON.stringify({
      items: [{ id: variantId, quantity: 1 }],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname,
    });
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(url + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: body,
    })
      .then(function (res) {
        if (!res.ok) return res.text().then(function (t) { throw new Error(t); });
        return res.json();
      })
      .then(function (state) {
        if (typeof window.publish === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'bk-cart-upsell',
            productVariantId: variantId,
            cartData: state,
          });
        }
      })
      .catch(function (err) {
        console.error('[bk-cart] upsell add failed', err);
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  }

  function init() {
    var drawer = getDrawer();
    if (!drawer) return;
    if (drawer.__bkInit) {
      restoreUpsellScroll();
      return;
    }
    drawer.__bkInit = true;

    drawer.addEventListener('click', function (e) {
      var addBtn = e.target.closest && e.target.closest('[data-bk-upsell-add]');
      if (addBtn) {
        e.preventDefault();
        onUpsellAdd(addBtn);
      }
    });

    restoreUpsellScroll();

    if (typeof window.subscribe === 'function' && typeof window.PUB_SUB_EVENTS !== 'undefined') {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(restoreUpsellScroll, 50);
      });
    }

    if (typeof MutationObserver === 'function') {
      var mo = new MutationObserver(function () {
        restoreUpsellScroll();
      });
      mo.observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
